import React from 'react';
import { IconButton, SvgIcon } from "@mui/material";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import { makeStyles } from "@mui/styles";
import { ReactComponent as UncheckIcon } from "../icons/uncheck-all.svg"

const CheckAll: React.FC<CheckAllProps> = props => {
    const styles = useStyles();
    return (
        <div className={ styles.root }>
            <IconButton
                size='small'
                onClick={ props.onCheckAllClick }
                className={ styles.checkBtn }
                title='Zaznacz wszystkie widoczne na liście'
            >
                <LibraryAddCheckIcon fontSize='small' color='secondary'/>
            </IconButton>
            <div className={ styles.divider }/>
            <IconButton
                size='small' onClick={ props.onUncheckAllClick }
                className={ styles.uncheckBtn }
                title='Odznacz wszystkie zaznaczone'
            >
                <SvgIcon component={ UncheckIcon } inheritViewBox fontSize='small' color='secondary'/>
            </IconButton>
        </div>
    );
}
export default CheckAll;

export interface CheckAllProps {
    readonly onCheckAllClick: () => void;
    readonly onUncheckAllClick: () => void;
}

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center'
    },
    divider: {
        height: '42px',
        borderLeft: '1px solid ' + theme.palette.grey[50],
        transform: 'rotate(50deg)',
        zIndex: 1000,
        borderColor: '#bababa'
    },
    checkBtn: {
        marginTop: '-1px',
        marginRight: '-4px !important',
        height: 'fit-content',
        padding: 0
    },
    uncheckBtn: {
        marginTop: '21px !important',
        marginLeft: '-5px !important',
        padding: '2px !important',
    },
}))